<template>
  <div class="device-detail-path-history">
    <!-- <div class="gutter"></div> -->
    <div class="sheet-info box">
      <ul class="box">
         <template v-for="func in deviceInfo.supportFunc.split(',')">

          <!-- 手工 v-if="deviceInfo.productBrand === 'ICE'-->
          <template v-if="func === 'manual'">
            <li class="item" :key="func">
              <p class="mode">{{ $t('dms_device_detail_path_history.ren_gong_qing_jie') }}</p>
              <ul>
                <li class="param">
                  <h2 :title="$t('dms_device_detail_path_history.qing_jie_shi_changhm')">
                    {{ $t('dms_device_detail_path_history.qing_jie_shi_changhm') }}
                  </h2>
                  <p>{{ info.manualUsageTime === 0 ? '-' : $formatSecToHm(info.manualUsageTime) }}</p>
                </li>
                <li class="param">
                  <h2 :title="$t('dms_device_detail_path_history.qing_jie_mian_jio', [$formatLenUnit()])">
                    {{ $t('dms_device_detail_path_history.qing_jie_mian_ji') }}{{$formatLenUnit()}}
                  </h2>
                  <p>{{ info.manualCleanArea === 0 ? '-' : $formatLenLocal($toFixed(info.manualCleanArea)) | formatThousandth}}</p>
                </li>
                <li class="param">
                  <h2 :title="$t('dms_device_detail_path_history.qing_jie_ci_shu')">
                  {{ $t('dms_device_detail_path_history.qing_jie_ci_shu') }}
                  </h2>
                  <p>{{ info.manualUsageCount }}</p>
                </li>
              </ul>
            </li>
          </template>
          <!-- 智能清洁 v-if="deviceInfo.productBrand === 'SBR'-->
          <template v-else-if="func === 'autonomous'">
            <li class="item" :key="func">
              <p class="mode">{{ $t('dms_device_detail_path_history.zi_zhu_qing_jie') }}</p>
              <ul>
                <li class="param">
                  <h2 :title="$t('dms_device_detail_path_history.qing_jie_shi_changhm')">
                    {{ $t('dms_device_detail_path_history.qing_jie_shi_changhm') }}
                  </h2>
                  <p>{{ info.autonomousUsageTime === 0 ? '-' : $formatSecToHm(info.autonomousUsageTime) }}</p>
                </li>
                <li class="param">
                  <h2 :title="$t('dms_device_detail_path_history.qing_jie_mian_jio', [$formatLenUnit()])">
                    {{ $t('dms_device_detail_path_history.qing_jie_mian_ji') }}{{$formatLenUnit()}}
                  </h2>
                  <p>{{ info.autonomousCleanArea === 0 ? '-' : $formatLenLocal($toFixed(info.autonomousCleanArea))| formatThousandth }}</p>
                </li>
                <li class="param">
                  <h2 :title="$t('dms_device_detail_path_history.fu_zhu_ci_shu')">
                    {{ $t('dms_device_detail_path_history.fu_zhu_ci_shu') }}
                  </h2>
                  <p>{{ info.assistCount }}</p>
                </li>
              </ul>
            </li>
          </template>
          <!-- 教学  v-if="deviceInfo.productBrand === 'SBR'-->
          <template v-else-if="func === 'training'">
            <li class="item" :key="func">
              <p class="mode">{{ $t('dms_device_detail_path_history.jiao_xue') }}</p>
              <ul>
                <li class="param">
                  <h2 :title="$t('dms_device_detail_path_history.jiao_xue_shi_changhm')">
                    {{ $t('dms_device_detail_path_history.jiao_xue_shi_changhm') }}
                  </h2>
                  <p>{{ info.trainingUsageTime === 0 ? '-' : $formatSecToHm(info.trainingUsageTime) }}</p>
                </li>
                <li class="param">
                  <h2 :title="$t('dms_device_detail_path_history.jiao_xue_mian_jio', [$formatLenUnit()])">
                    {{ $t('dms_device_detail_path_history.jiao_xue_mian_ji') }}{{$formatLenUnit()}}
                  </h2>
                  <p>{{ info.trainingCleanArea === 0 ? '-' : $formatLenLocal($toFixed(info.trainingCleanArea))| formatThousandth }}</p>
                </li>
              </ul>
            </li>
          </template>
          <!-- 开机 -->
          <template v-else-if="func === 'boot'">
            <li class="item" :key="func">
              <p class="mode">{{ $t('dms_device_detail_path_history.kai_ji') }}</p>
              <ul>
                <li class="param">
                  <h2 :title="$t('dms_device_detail_path_history.kai_ji_shi_changhm')">
                    {{$t('dms_device_detail_path_history.kai_ji_shi_changhm')}}
                  </h2>
                  <p>{{ info.bootTime === 0 ? '-' : $formatSecToHm(info.bootTime) }}</p>
                </li>
                <li class="param">
                  <h2 :title="$t('dms_device_detail_path_history.kai_ji_ci_shu')">
                    {{$t('dms_device_detail_path_history.kai_ji_ci_shu')}}
                  </h2>
                  <p>{{ info.bootCount }}</p>
                </li>
              </ul>
            </li>
          </template>
           <!-- 充电 v-if="deviceInfo.productBrand === 'ICE'"-->
          <template  v-else-if="func === 'charging'">
            <li class="item" :key="func">
              <p class="mode">{{ $t('dms_device_detail_path_history.chong_dian') }}</p>
              <ul>
                <li class="param">
                  <h2 :title="$t('dms_device_detail_path_history.cdschm')">
                    {{ $t('dms_device_detail_path_history.cdschm') }}
                  </h2>
                  <p>{{ info.chargingTime === 0 ? '-' : $formatSecToHm(info.chargingTime) }}</p>
                </li>
              </ul>
            </li>
          </template>
        </template>
      </ul>
    </div>
    <div class="data-detail">
      <!-- <div class="header">
        <div class="title">{{ $t('page_content_boot_card_use_details1 }}</div>
        <el-button
          size="mini"
          class="export"
          type="primary"
          @click="exportPath"
          >{{ $t('com_export_data }}</el-button
        >
      </div> -->
      <div class="search-hd">
        <el-form :inline="true" @submit.native.prevent>
          <!-- <el-form-item>
            <p class="titel">
              {{ $t('page_content_boot_card_use_details1 }}
            </p>
          </el-form-item> -->
          <el-form-item style="float: right; margin-right: 0">
            <custom-column ref="column"></custom-column>
          </el-form-item>
          <el-form-item style="float: right">
            <el-button class="table-set" style="vertical-align: top" @click="exportPath">
              <i class="icon icon-daochu"></i>
            </el-button>
          </el-form-item>
          <el-form-item style="float: right">
            <switch-button :link="$refs.container"></switch-button>
          </el-form-item>
        </el-form>
      </div>
      <switch-container ref="container" @search="getTableList()" @clear="clearFilter()">
        <el-form :inline="true" label-position="top">
          <!-- 站点 -->
          <el-form-item :label="$t('dms_device_detail_path_history.zhan_dian')">
            <custom-select
              url="DeviceReportSiteSiteList"
              :props="{ label: 'siteName', value: 'siteCode' }"
              :listener="`${formSearch.bodyNum}${formSearch.startTime}${formSearch.endTime}`"
              :placeholder="$t('Common.com_please_select')"
              :params="{ ...formSearch }"
              v-model="formSearch.siteCode"
              :noBoder="true"
              width="100%"
            ></custom-select>
          </el-form-item>
          <!-- 定位码 -->
          <el-form-item :label="$t('dms_device_detail_path_history.ding_wei_ma')">
            <el-input v-model="formSearch.hlcCode" placeholder="" style="width: 100%"></el-input>
          </el-form-item>
          <el-form-item :label="$t('dms_device_detail_path_history.lu_xian_cao')">
            <el-input v-model="formSearch.slotCode" placeholder="" style="width: 100%"></el-input>
          </el-form-item>
          <el-form-item :label="$t('dms_device_detail_path_history.mo_shi')">
            <custom-select v-model="formSearch.workClass" code="iot_tsl_use_type2" :placeholder="$t('Common.com_please_select')" width="100%"></custom-select>
          </el-form-item>
          <!-- 地图名称 -->
          <el-form-item :label="$t('dms_device_detail_path_history.di_tu_ming_cheng')">
            <el-input v-model="formSearch.mapName" placeholder="" style="width: 100%"></el-input>
          </el-form-item>
        </el-form>
      </switch-container>
      <div class="table-bd">
        <custom-table :data="tableList" :index="true" @sort="sortChange"
        v-if="isInch"
        tableCode="device_sheet_day_zone_ft"
        @filter="filterChange"
        @column="setColumn"
        :slots="['runRoute','cleanedArea','runLength']">
        <template v-slot:cleanedArea="scope">
            <span>{{$formatLenLocal(scope.row.cleanedArea)| formatThousandth}}</span>
          </template>
          <template v-slot:runLength="scope">
            <span>{{$formatLenLocal(scope.row.runLength,true)}}</span>
          </template>
          <template v-slot:runRoute="scope">
            <span
              v-if="!!scope.row.routeId && (`${scope.row.workClass}` === '5' || `${scope.row.workClass}` === '4')"
              style="cursor: pointer; color: #0d9ae0"
              @click="mapIdDetails(scope.row.routeId, scope.row.workClass)"
            >
              {{ $t('Common.com_detail') }}
            </span>
          </template>
          <!-- mapDetails -->
        </custom-table>
        <custom-table :data="tableList" :index="true" @sort="sortChange"
        v-else
        tableCode="device_sheet_day_zone"
        @filter="filterChange"
        @column="setColumn"
        :slots="['runRoute']">
          <template v-slot:runRoute="scope">
            <span
              v-if="!!scope.row.routeId && (`${scope.row.workClass}` === '5' || `${scope.row.workClass}` === '4')"
              style="cursor: pointer; color: #0d9ae0"
              @click="mapIdDetails(scope.row.routeId, scope.row.workClass)"
            >
              {{ $t('Common.com_detail') }}
            </span>
          </template>
          <!-- mapDetails -->
        </custom-table>
      </div>
      <div class="table-page">
        <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
      </div>
      <!-- 查看地图图片 -->
      <el-image-viewer v-if="dialogVisibleImage" class="img"  :url-list="[dialogImageUrl]"  :on-close="()=>dialogVisibleImage=false" ></el-image-viewer>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import moment from 'moment';

export default {
  components: {},
  props: {
    pathTimer: [Object, Array],
    deviceInfo: [Object, Array],
    isCharging: {
      type: Boolean,
      default: false,
    },
    isManual: {
      type: Boolean,
      default: false,
    },
    isAutonomous: {
      type: Boolean,
      default: false,
    },
    isTraining: {
      type: Boolean,
      default: false,
    },
    isBoot: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    pathTimer() {
      // 这里特殊 要用报表的偏移时间去调接口utcReportOffset
      this.formSearch.startTime = this.pathTimer && this.pathTimer[0]
        ? moment
          .utc(this.$momentElLocal(this.pathTimer[0]))
          .utcOffset(this.deviceInfo.utcReportOffset || 0)
          .format('YYYY-MM-DD HH:mm:ss')
        : undefined;
      this.formSearch.endTime = this.pathTimer && this.pathTimer[1]
        ? moment
          .utc(this.$momentElLocal(this.pathTimer[1]))
          .utcOffset(this.deviceInfo.utcReportOffset || 0)
          .format('YYYY-MM-DD HH:mm:ss')
        : undefined;
      this.formSearch.bodyNum = this.deviceInfo.bodyNum;
      this.getSiteCount();
      this.getTableList();
      // this.getSiteList();
    },
  },
  data() {
    return {
      tableCode: 'device_sheet_day_zone',
      tableList: [],
      totalRows: null,
      formSearch: {
        pageSize: 20,
        pageNum: 1,
        // bodyNum: '0002190500067',
        // startTime: '2020-06-12 00:00:00',
        // endTime: '2020-06-12 23:59:59',

        // bodyNum: this.deviceInfo.bodyNum,
        // startTime: this.pathTimer[0],
        // endTime: this.pathTimer[1],

        // 筛选
        siteCode: '', // 站点
        hlcCode: '', // 定位码
        slotCode: '', // 路径
        workClass: '', // 模式
        mapName: '', // 模式
      },
      info: {
        // ICE
        chargingTime: '', // 充电时长
        manualUsageTime: '', // 手工清洁时间
        manualCleanArea: '', // 手工清洁面积
        manualUsageCount: '', // 手工清洁次数
        lastDataUploadedTime: '', // 最后清洁时间
        // SBR
        // 手工清洁时长 h:m ,
        // 手工清洁面积 m²,
        autonomousUsageTime: '', // 智能清洁时长 h:m',
        autonomousCleanArea: '', // 智能清洁面积 m²',
        assistCount: '', // 辅助次数,
        trainingUsageTime: '', // 教学时长 h:m,
        trainingCleanArea: '', // 教学面积 m²,
        totalUsageCount: '', // 清洁次数,
        bootTime: '', // 开机时长 h:m,
        bootCount: '', // 开机次数,
      },
      siteList: [],
      hlcCodeList: [],
      slotList: [],

      dialogVisibleImage: false,
      dialogImageUrl: '',
    };
  },
  methods: {
    // 获取统计数
    getSiteCount() {
      this.$getJSON(apis.DeviceReportWorkRunCount, this.formSearch).then((res) => {
        if (res.data && Object.keys(res.data).length !== 0) {
          this.$setFormatData(this.info, res.data);
        } else {
          this.info.chargingTime = '';
          this.info.manualUsageTime = '';
          this.info.manualRunLength = '';
          this.info.manualCleanArea = '';
          this.info.manualUsageCount = '';
          this.info.autonomousUsageTime = '';
          this.info.autonomousRunLength = '';
          this.info.autonomousCleanArea = '';
          this.info.trainingUsageTime = '';
          this.info.trainingRunLength = '';
          this.info.trainingCleanArea = '';
          this.info.assistCount = '';
          this.info.totalUsageCount = '';
          this.info.bootTime = '';
          this.info.bootCount = '';
        }
      });
    },
    // 获取列表数据
    getTableList() {
      this.$getJSON(apis.DeviceDeviceReportWorkRunPage, this.formSearch).then((res) => {
        const data = res.data.list || [];
        // 如果是充电模式
        data.forEach((i) => {
          if (`${i.workClass}` === '1') {
            i.siteName = '-';
            i.hlcCode = '-';
            i.slotCode = '-';
            i.cleanedArea = '-';
            i.usageTimeFormat = '-';
            i.runLength = '-';
            i.assistCount = '-';
          }
        });
        this.nullValueToCrossbar(data, ['assistCount']);
        this.tableList = data;
        // this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 获取站点下拉节点
    // getSiteList() {
    //   this.$getJSON(apis.DeviceReportSiteSiteList, this.formSearch).then((res) => {
    //     this.siteList = res.data;
    //   });
    // },
    // changeSiteCode() {
    //   this.hlcCodeList = [];
    //   this.formSearch.hlcCode = '';
    //   this.slotList = [];
    //   this.formSearch.slotCode = '';

    //   this.getLocationCodeList();
    //   this.onSizeChange(1);
    // },
    // getLocationCodeList() {
    //   this.$getJSON(apis.DeviceReportSiteLocationCodeList, this.formSearch).then((res) => {
    //     this.hlcCodeList = res.data;
    //   });
    // },
    // changeLocationCode() {
    //   this.slotList = [];
    //   this.formSearch.slotCode = '';
    //   this.getSlotList();
    //   this.onSizeChange(1);
    // },
    // getSlotList() {
    //   this.$getJSON(apis.DeviceReportSiteSlotList, this.formSearch).then((res) => {
    //     this.hlcCodeList = res.data;
    //   });
    // },
    // changeSlotList() {
    //   this.onSizeChange(1);
    // },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    // 导出数据
    exportPath: function () {
      this.$exportFlie(apis.DeviceReportWorkRunExport, { ...this.formSearch, tableCode: this.isInch ? 'device_sheet_day_zone_ft' : 'device_sheet_day_zone' }).then(() => {});
    },
    mapIdDetails(routeId, workClass) {
      // w是自主
      // t是教学
      let type = '';
      if (`${workClass}` === '5') {
        type = 'w';
      } else if (`${workClass}` === '4') {
        type = 't';
      }
      if (!routeId || !type) {
        return;
      }
      this.$getJSON(`${apis.OssAttach}/${routeId}/${type}`).then((res) => {
        const list = res.data || [];
        const url = this.getAttachUrl(list[0]);
        this.dialogImageUrl = url;
        this.dialogVisibleImage = true;
      });
    },
    // 查看地图
    mapDetails: function (url) {
      this.dialogVisibleImage = true;
      this.dialogImageUrl = url;
    },
    clearFilter: function () {
      this.formSearch.siteCode = ''; // 站点
      this.formSearch.hlcCode = ''; // 定位码
      this.formSearch.slotCode = ''; // 路径
      this.formSearch.mapName = ''; // 地图名称
      this.formSearch.workClass = ''; // 模式
      this.getTableList();
    },
  },
  mounted() {
    this.resetFormSearch = JSON.stringify(this.formSearch);
    // this.getTableColumn();
    // this.formSearch.startTime = this.pathTime && this.pathTime[0] ? this.pathTime[0] : undefined;
    // this.formSearch.endTime = this.pathTime && this.pathTime[1] ? this.pathTime[1] : undefined;
    // 这里特殊 要用报表的偏移时间去调接口utcReportOffset
    this.formSearch.startTime = this.pathTimer && this.pathTimer[0]
      ? moment
        .utc(this.$momentElLocal(this.pathTimer[0]))
        .utcOffset(this.deviceInfo.utcReportOffset || 0)
        .format('YYYY-MM-DD HH:mm:ss')
      : undefined;
    this.formSearch.endTime = this.pathTimer && this.pathTimer[1]
      ? moment
        .utc(this.$momentElLocal(this.pathTimer[1]))
        .utcOffset(this.deviceInfo.utcReportOffset || 0)
        .format('YYYY-MM-DD HH:mm:ss')
      : undefined;
    this.formSearch.bodyNum = this.deviceInfo.bodyNum;
    this.getSiteCount();
    this.getTableList();
    // this.getSiteList();
  },
};
</script>

<style lang="scss">
.device-detail-path-history {
  .gutter {
    height: 16px;
    background: #e4ebf2;
  }
  .sheet-info {
    margin-top: 16px;
    .box {
      padding: 0 16px;
      display: flex;
      li.item {
        border-right: 1px solid #e9ebec;
        margin-left: 32px;
        &:first-child {
          margin: 0;
        }
        .mode {
          height: 28px;
          font-size: 15px;
          font-weight: bold;
          color: #0d9ae0;
          line-height: 28px;
          margin-bottom: 12px;
        }
        ul {
          display: flex;
          .param {
            padding-right: 32px;
            h2 {
              height: 17px;
              font-size: 12px;
              color: rgba(152, 166, 173, 1);
              line-height: 17px;
              margin-bottom: 5px;
              white-space: normal;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            p {
              height: 26px;
              font-size: 22px;
              font-weight: bold;
              color: rgba(57, 70, 104, 1);
              line-height: 26px;
            }
          }
        }

        &:last-of-type {
          border: none;
        }
      }
    }
    .time {
      color: #0d9ae0;
    }
    .box-bottom {
      margin-top: 16px;
      text-align: right;
      height: 17px;
      font-size: 12px;
      color: #6c757d;
      line-height: 17px;
    }
  }
  .filter-content {
    background-color: #fff;
    padding: 0px 24px 24px;
    .box {
      background: #f6f6fa;
      padding: 16px 24px 19px 24px;
    }

    .el-form-item {
      width: 100%;
      margin-bottom: 0 !important;
    }

    .el-form-item__label {
      width: 100%;
      text-align: left;
      color: #495057;
      font-weight: bold;
    }

    .el-form-item__content {
      width: 100%;
    }
  }

  .param-list {
    height: 90px;
    width: 100%;
    overflow-x: auto;
    padding: 20px 25px;
    background-color: #fff;
    > li {
      float: left;
      width: 150px;
      padding-left: 24px;

      &:nth-child(n + 2) {
        border-left: 1px solid #e9ebec;
      }
      .name {
        font-size: 12px;
        color: #98a6ad;
        line-height: 17px;
      }
      .val {
        color: #394668;
        font-size: 20px;
        font-weight: bold;
        line-height: 26px;
        margin-top: 7px;
      }
    }
  }
  .data-detail {
    padding: 24px;
    background-color: #fff;
    margin-top: 16px;
    .search-hd {
      padding: 0 0 24px;
    }
    .header {
      overflow: hidden;
      .title {
        float: left;
        line-height: 28px;
        font-weight: bold;
        color: #495057;
        font-size: 14px;
      }
      .export {
        float: right;
      }
    }
  }
  .el-select {
    .el-input__inner {
      border: 0;
    }
  }
  .table-bd {
    // margin-top: 24px;
  }
}
</style>
